import { V1_ACCESS_CHECK_ENDPOINT, V1_ACCESS_REQUEST_TIMEOUT_MS } from 'src/lib/constants';

/** Reads the V1/V2 cutover flag the V2 admin controls. Throws on any network/HTTP failure. */
export const getV1AccessMode = async (apiUrl) => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), V1_ACCESS_REQUEST_TIMEOUT_MS);
  try {
    const response = await fetch(`${apiUrl.replace(/\/$/, '')}${V1_ACCESS_CHECK_ENDPOINT}`, {
      signal: controller.signal,
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const body = await response.json();
    return body?.data?.mode;
  } finally {
    clearTimeout(timeout);
  }
};
